import Vue from 'vue'
import axios from 'axios';
import Config from '../config/config'
import { Loading, Message } from 'element-ui';
import router from "../router/index"
let loadingInstance = null;
const errorHandler = (err) => {
	Promise.reject(err).catch(() => {
		if (err) {
			switch (err.code) {
				case "02001":
					Message({
                        message: err.message,
                        type: 'error'
                    })
					break;
				default:
                    Message({
                        message: err.message || '系统错误',
                        type: 'error'
                    })
					break
			}
		}
	})
}

// 创建axios实例
const ajax = axios.create({
	baseURL: Config.echartsUrl,
	timeout: 15000,
	// withCredentials: true
})
const formatParams = function (params) {
	for (let name in params) {
		if (params[name] instanceof Date) {
			params[name] = params[name].getTime()
		}
	}
	return params
}

const getFormData = function (data) {
	var buildParams = function (prefix, obj, add) {
		if (obj instanceof Array) {
			// Serialize array item.
			obj.forEach(function (v, i) {
				if (/\[\]$/.test(prefix)) {
					// Treat each array item as a scalar.
					add(prefix, v);
				} else {
					buildParams(prefix + (typeof v === 'object' ? '[' + i + ']' : ''), v, add);
				}
			});

		} else if (obj instanceof Date) {
			add(prefix, obj.getTime());
		} else if (obj != null && typeof obj === 'object') {
			// Serialize object item.
			for (var name in obj) {
				buildParams(prefix + "." + name, obj[name], add);
			}
		} else {
			// Serialize scalar item.
			add(prefix, obj);
		}
	};
	var formData = new FormData();
	var append = function (key, value) {
		value = (typeof (value) == 'function') ? value() : value;
		if (value !== undefined && value !== null) {
			formData.append(key, value)
		}
	};

	// If an array was passed in, assume that it is an array of form elements.
	if (data instanceof Array) {
		// Serialize the form elements
		data.forEach(function (item, i) {
			buildParams('[' + i + ']', item, append);
		});
	} else {
		for (var prefix in data) {
			buildParams(prefix, data[prefix], append);
		}
	}
	return formData;
}
ajax.interceptors.request.use(config => {
    console.log(config)
    config.headers["X-Requested-With"] = "XMLHttpRequest"
    const isPutPost = config.method === 'put' || config.method === 'post'
	const isjson = config.headers['Content-Type'] === 'application/json'
	if (isPutPost) {
		if (isjson) {
			config.data = JSON.stringify(config.data)
		} else {
			if (!(config.data instanceof FormData)) {
				config.data = getFormData(config.data)
			}
		}
	} else {
		formatParams(config.params)
	}

	if (config.method == 'get') {
		config.params = {
			...config.params,
			...{ '_t': new Date().getTime() }
		}
	}
    return config;
});

ajax.interceptors.response.use(res => {

    setTimeout(() => {
        loadingInstance && loadingInstance.close();

    }, 300);
    if (res.status == 200) {
        if (res.data.Success) {
            return Promise.resolve(res.data);
        }
		console.log(res.data)
        if (res.data.code == '000') {
            if (res.config.loading) {
                //关闭加载
            }
            return Promise.resolve(res.data.data);
        }else if (res.data.code == '44444') {
            if (res.config.loading) {
                //关闭加载
            }
            return Promise.resolve(res.data);
        }
        else {
            let err = {
                code: res.data.code,
                message: res.data.message || '请求失败'
            }
            errorHandler(err)
        }
    } else {
        return Promise.reject(res.data.msg);
    }
}, function (error) {
    loadingInstance && loadingInstance.close();
    return Promise.reject(error);

});

Vue.prototype.$ajax = ajax;